import './Status.scss';

export const Status = ({title, color = "default"}) => {

    return (
        <div className={`status --${color}`}>
            {title}
        </div>
    )
}